module.exports = ".strikethrough {\r\n    text-decoration: line-through;\r\n}\r\n"